module.exports = __webpack_public_path__ + "img/event_mb_tab_02.5cfe76c7.png";